// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2GjdW","backdrop":"Modal_backdrop__3FAPo","modal":"Modal_modal__P3_V5","dark":"Modal_dark__2wEuJ"};